module.exports = __webpack_public_path__ + "img/BEARD 2.478fcf8.svg";